import { ChatBubbleLeftEllipsisIcon, ChevronRightIcon, ShieldCheckIcon, UserCircleIcon } from '@heroicons/react/24/outline';
import { useDispatch, useSelector } from 'react-redux';
import Loyality from '../Loyality';
import { RelativeHeader } from '../Header';
import { HeaderSlot } from '../../../utils/constants';
import { MyProfileBackground } from '../../../utils/svg';
import Powered from '../Powered';
import Form from './Form';
import { clearUser } from '../../../store/reducers/user';
import { clearCart } from '../../../store/reducers/cart';

const Profile = (props) => {
	const { onClose } = props;
	const dispatch = useDispatch();
	const user = useSelector((store) => store?.user);

	const menu = [
		{
			label: 'How to Order',
			leftIcon: <ChatBubbleLeftEllipsisIcon className='h-6 w-6 text-gray-600' />,
			rightIcon: <ChevronRightIcon className='h-3 sm:h-4 w-auto text-gray-600' strokeWidth={3} />,
		},
		{
			label: 'Privasi Policy',
			leftIcon: <ShieldCheckIcon className='h-6 w-6 text-gray-600' />,
			rightIcon: <ChevronRightIcon className='h-3 sm:h-4 w-auto text-gray-600' strokeWidth={3} />,
		},
	];

	const headerProps = {
		slots: {
			left: {
				content: HeaderSlot.BACK,
				route: onClose,
        className: '!opacity-100 transform !translate-y-0',
			},
			center: {
				content: HeaderSlot.NAME,
				title: 'My Profile',
        className: '!opacity-100 !translate-y-0 ml-2'
			},
		},
		parent: {
			border: {
				bottom: true,
			},
		},

	};

	const loyaltyProps = {
		className: '!rounded-md',
		...props,
	};

	const handleSignOut = () => {
		dispatch(clearUser());
    dispatch(clearCart());
		onClose?.();
	};

	return (
		<>
			<div className='m-4'>
				<RelativeHeader {...headerProps} />
				<div className='flex items-center justify-between px-2 py-4 relative -mx-4'>
					<MyProfileBackground className={'absolute top-0 left-0 w-screen z-0'} />
					<div className='flex items-center gap-2 z-5'>
						<UserCircleIcon className='h-16 w-16 text-white fill-gray-800' />
						<div className='text-white text-sm'>
							<div className='font-semibold capitalize'>Hi, {user?.firstName}</div>
							<div className='font-normal'>{user?.primary_phone}</div>
						</div>
					</div>
					<Form />
				</div>
				<div className='rounded-t-xl p-4 -mx-4 relative z-5 bg-white'>
					<Loyality {...loyaltyProps} />
					<div className='flex flex-col gap-4 py-6'>
						{menu?.map((m, index) => {
							return (
								<div key={index} className='flex items-center justify-between p-2'>
									<div className='flex items-center gap-2'>
										<div>{m?.leftIcon}</div>
										<div className='text-xs font-normal text-gray-800'>{m?.label}</div>
									</div>
									<div>{m?.rightIcon}</div>
								</div>
							);
						})}
					</div>
					<button id='ufood-x-sign-out' className={`border-none text-red-500 bg-red-400/20 p-4 text-sm font-semibold rounded-md w-full`} onClick={handleSignOut}>
						Sign Out
					</button>
					<div className='mt-10'>
						<Powered />
					</div>
				</div>
			</div>
		</>
	);
};

export default Profile;
